<template>
    <textarea
        v-bind="$attrs"
        class="form-textarea"
        ref="textarea"
        v-on="listeners"
    />
</template>

<script>
    export default {
        computed: {
            listeners() {
                return {
                    ...this.$listeners,
                    input: e => this.$emit('input', e.target.value),
                };
            },
        },

        methods: {
            focus() {
                this.$refs.textarea.focus();
            },
        },
    };
</script>
